import React, { Fragment, useState } from "react";
import { Card, Button, Upload, Modal, Input, message, Spin } from "antd";
import { DownloadOutlined, DeleteOutlined, FilePdfOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { ROLES } from "./constants/roles";

const { confirm } = Modal;

export default function IOUDocumentUpload({ DOC_ADD, filesList, setFileList, view, onFileDelete, userId, status }) {
  const [loading, setLoading] = useState(false);

  const api_base_url = process.env.REACT_APP_BASE_URL;
  const token = localStorage.getItem("token");
  const props = {
    action: api_base_url + DOC_ADD,
    accept: "image/*,.pdf, .doc, .xlsx",
    headers: {
      authorization: `Bearer ${token}`,
    },
    showUploadList: false,
    data: (file) => ({
      attachment_name: file.name,
      attachment: file,
    }),
    beforeUpload: (file) => {
      setLoading(true);
      return true;
    },
    onChange(info) {
      if (info.file.status === "uploading") {
        setLoading(true);
      }
      if (info.file.status === "done" && info?.file?.response.code == 200) {
        setLoading(false);
        let content = {
          id: info?.file?.response?.data?.id,
          name: info?.file?.response?.data?.attachment_name,
          path: info?.file?.response?.data?.attachment,
        };
        setFileList((prevFiles) => [...prevFiles, content]);

        message.success(`${info?.file?.response?.data?.attachment_name} file uploaded successfully`);
      } else if (info.file.status === "done" && info?.file?.response.code !== 200) {
        setLoading(false);
        message.error(`${info.file.name} file upload failed.`);
      } else if (info.file.status === "error") {
        setLoading(false);
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const removeFile = (index) => {
    confirm({
      title: "Do you Want to delete these items?",
      icon: <ExclamationCircleOutlined />,

      onOk() {
        const fileToDelete = filesList[index];
        if (onFileDelete) {
          onFileDelete(fileToDelete.id);
        }
        let items = filesList;
        items.splice(index, 1);
        setFileList([...items]);
      },
      onCancel() {},
    });
  };

  const onChangeHandel = (val, index, context) => {
    filesList[index][context] = val;
    setFileList([...filesList]);
  };

  const loggedInUserId = parseInt(localStorage.getItem("user_id"), 10);
  const loggedInUserRole = localStorage.getItem("user_type");

  const canUploadDocument = React.useMemo(() => {
    // if (!loggedInUserRole) return false;
    // if (loggedInUserId !== userId) return false;
    return true;
  }, [loggedInUserRole, userId]);

  return (
    <Spin spinning={loading}>
      <Card className="mt-3 custome-table" title="Upload Document">
        <div className="root-table">
          <table>
            <thead>
              <tr>
                <th className="t-header bc-java">Serial</th>
                <th className="t-header bc-java">Document Name</th>
                <th className="t-header bc-java">File</th>
                <th className="t-header bc-java"></th>
              </tr>
            </thead>
            <tbody>
              {filesList?.length ? (
                <>
                  {filesList.map((file, index) => (
                    <Fragment key={index}>
                      <tr>
                        <td className="t-body">{index + 1}</td>
                        <td className="t-body">{file.name}</td>
                        <td className="t-body">
                          <Button type="text" onClick={() => window.open(api_base_url + "/" + file.path, "_blank")}>
                            <FilePdfOutlined />
                          </Button>
                        </td>
                        {!view && (
                          <td className="t-body">
                            <DeleteOutlined
                              style={{ fontSize: "20px", color: "red" }}
                              className="cursore-pointer"
                              onClick={() => removeFile(index)}
                            />
                          </td>
                        )}
                      </tr>
                    </Fragment>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", padding: "10px", color: "#999", fontWeight: "bold" }}>
                    No document uploaded yet!
                  </td>
                </tr>
              )}

              <tr>
                <td className="t-body"></td>
                <td className="t-body"></td>
                <td className="t-body"></td>
                <td className="t-body">
                  {!view && (status === "created" || status === 'rejected') && (
                    <Upload {...props}>
                      <Button type="primary" icon={<DownloadOutlined />} loading={loading}>
                        Upload
                      </Button>
                    </Upload>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </Spin>
  );
}
